export const configData = {
    SECRET_KEY: "shining-on-safety",// This SECRET_KEY crypto-js
    WEEK_ARRAY: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    MONTH_NAME: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
   // IP_INFO: "https://ipinfo.io/json?token=a0faf8805063c2" //old- test 
    IP_INFO: "https://ipinfo.io/json?token=879c5ce2a3ddd5" // Live- new
}